function initProductSlider() {
  const mediaListEl = document.querySelector('.product__media-list');
  if (!mediaListEl) return;

  // Build options based on current slide count
  const hasMultipleSlides = mediaListEl.querySelectorAll('.swiper-slide').length > 1;

  const productSliderOptions = hasMultipleSlides
    ? {
        slidesPerView: 1.1,
        // Disable loop to keep slide indices in sync with thumbnails,
        // and to avoid issues when we hide/show slides for variants.
        loop: false,
        spaceBetween: 14,
        allowTouchMove: true,
        centeredSlides: true,
        pagination: {
          el: '.product__media-pagination',
          clickable: true,
        },
        breakpoints: {
          769: {
            slidesPerView: 1,
            spaceBetween: 20,
            allowTouchMove: false,
            centeredSlides: false,
          },
        },
      }
    : {
        slidesPerView: 1,
        loop: false,
        spaceBetween: 0,
        allowTouchMove: false,
        breakpoints: {
          769: {
            slidesPerView: 1,
            spaceBetween: 0,
            allowTouchMove: false,
          },
        },
      };

  // Create Swiper
  const productSlider = new Swiper(mediaListEl, productSliderOptions);
  // Expose for other scripts (e.g., variant change) to update/re-init
  window.productSlider = productSlider;

  // Sync slider with thumbnails
  productSlider.on('slideChange', (slider) => {
    const idx = slider.realIndex;
    const activeThumb = document.querySelector('.product__media-thumbnail-item.active');
    const newThumb = document.querySelector(`.product__media-thumbnail-item[data-index="${idx}"]`);

    if (activeThumb) activeThumb.classList.remove('active');
    if (newThumb) newThumb.classList.add('active');
  });

  // Sync thumbnails with slider
  const thumbnails = document.querySelectorAll('.product__media-thumbnail-item');

  // Ensure there is always an active thumbnail
  if (thumbnails.length && !document.querySelector('.product__media-thumbnail-item.active')) {
    thumbnails[0].classList.add('active');
  }

  thumbnails.forEach((thumbnail) => {
    thumbnail.onclick = (event) => {
      const idx = Number(event.currentTarget.dataset.index);

      if (productSlider.params.loop) {
        productSlider.slideToLoop(idx);
      } else {
        productSlider.slideTo(idx);
      }
    };
  });

  // Sync media to selected variant (variant-specific images by alt)
  const productForMedia = mediaListEl.closest('.product');
  const variantEl =
    productForMedia?.querySelector('variant-radios') || productForMedia?.querySelector('variant-selects');
  if (variantEl && typeof variantEl.updateMedia === 'function') {
    variantEl.updateOptions?.();
    variantEl.updateMasterId?.();
    variantEl.updateMedia();
  }
}

// Initial slider init on page load
initProductSlider();
// Expose initializer for re-init after variant/media changes
window.initProductSlider = initProductSlider;

customElements.define('product-form', class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartDrawer = document.querySelector('cart-drawer');
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);


          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        }));

        console.log(parsedState)
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('disabled');
        this.cartDrawer.open();
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer__content',
        section: document.getElementById('cart-drawer__content').dataset.id,
        selector: '.cart-drawer__content',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-upsell-price',
        section: 'main-product',
        selector: '.product-upsell__button .price'
      }
    ];
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleErrorMessage(errorMessage = false) {
    this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
    this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

    this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

    if (errorMessage) {
      this.errorMessage.textContent = errorMessage;
    }
  }
});